import { render, staticRenderFns } from "./PasswordRecoveryEnd.vue?vue&type=template&id=ba2ecc64&"
import script from "./PasswordRecoveryEnd.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoveryEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports